import { Inject, Injectable } from '@angular/core';
import { MsalPolicyService } from '@modules/core/services/msalPolicy.service';
import { from, Observable } from 'rxjs';
import { Environment } from '../../../app/types/environment.interface';
import { AddHeadersRequestPolicy } from '../../addresses-store/util';
import { ENVIRONMENT } from '../../core/types';
import {
  FareRequest,
  FareSelectorList,
  FareSelectorRequest,
  GetFareResponse,
  TicketFaresAPI,
  TicketFaresAPIOptionalParams,
  TicketProduct,
} from '../client/src';

const PAYG_FARES = 'PayAsYouGo';
const FLEXIBLE_FARES = 'Flexible';

@Injectable({
  providedIn: 'root',
})
export class TicketsAndFaresService {
  protected readonly baseApi: TicketFaresAPI;

  constructor(
    @Inject(ENVIRONMENT) private env: Environment,
    private msalPolicyService: MsalPolicyService
  ) {
    const clientParams: TicketFaresAPIOptionalParams = {
      endpoint: `${env.nxApi.base}/${env.nxApi.fragment.ticketsAndFares}`,
      additionalPolicies: [
        { policy: new AddHeadersRequestPolicy(), position: 'perCall' },
        // { policy: msalPolicyService.buildPipelinePolicy(), position: 'perCall'}
        //TODO: remove example of adding policy left here for future APIs
      ],
      retryOptions: {
        maxRetries: 0,
      },
    };

    this.baseApi = new TicketFaresAPI(clientParams);
  }

  public loadFareSelectors(
    fareSelectorRequest: FareSelectorRequest
  ): Observable<FareSelectorList> {
    return from(
      this.baseApi.getFareSelectorList({
        body: {
          ...fareSelectorRequest,
        },
      })
    );
  }

  public loadPaygFares(): Observable<GetFareResponse> {
    return from(
      this.baseApi.getFareByBundle({
        body: {
          bundleName: PAYG_FARES,
        },
      })
    );
  }

  public loadFlexibleFares(): Observable<GetFareResponse> {
    return from(
      this.baseApi.getFareByBundle({
        body: {
          bundleName: FLEXIBLE_FARES,
        },
      })
    );
  }

  public loadFareById(ticketId: string): Observable<TicketProduct> {
    return from(this.baseApi.getFareByTicketID(ticketId));
  }

  public loadFareByALias(ticketAlias: string): Observable<TicketProduct> {
    return from(this.baseApi.getFareByQueryStringTicketCode(ticketAlias));
  }

  public searchFares(fareRequest: FareRequest): Observable<GetFareResponse> {
    return from(
      this.baseApi.getFare({
        body: fareRequest,
      })
    );
  }
}
